import { render, staticRenderFns } from "./AddKeywords.vue?vue&type=template&id=f13f322c&"
import script from "./AddKeywords.vue?vue&type=script&lang=js&"
export * from "./AddKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports